export const isAgentsEnabled = (raw: string | undefined = import.meta.env.VITE_AGENTS_ENABLED): boolean => raw === "true";
